import React, {Component, Fragment } from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';

const initialState = {
  id: '',
  birth_d: '',
  birth_m: '',
  birth_y: '',
  password: '',
  rePassword: '',
  otp: '',
  onetimeTid: '',
  maskmail: '',
  mailCheck: false,
  complete: false,
  errorMap: null,
  loading : false,
  showPwd: false,
  maskphonenumber: '',
  requestId:''
}

class PwdReset extends Component {
  state=initialState;

  // 初期表示処理
  componentDidMount() {

    // GA計測用データレイヤースクリプトを追加する
    window.addDataLayerScript('jmbauth_pwd_reset_start');

    // 生年月日表示設定処理を呼出す
    window.addDateControl();

    // 年の初期値をstateに設定する
    this.setState({ birth_y: document.getElementById('birth_y').value });

  }

  // パスワードリセット画面[変更]ボタン押下時処理
  pwdReset = async () => {

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken = null;
    // セッショントークン格納変数の宣言
    let sessionToken;
    // stateのお得意様番号(00パディング後)
    let requestId = this.state.requestId;

    // SDK呼出(アクションレポート)
    try{
      // 外部メソッドの「クリアユーザー処理」を呼び出す
      await window.tsPlatform.drs.clearUser();

      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("password_reset_reset", { correlationId: l_sid , claimedUserId: requestId });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
          }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    // SDK呼出(セッショントークン取得)
    try {
      // セッショントークン取得
      sessionToken = await window.tsPlatform.drs.getSessionToken();
    } catch (e) {
    }

    const { password, rePassword, otp, onetimeTid } = this.state;

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // バリデーションチェックを行う
    if (password === '') {
      this.setState({ errorMap: { ERROR: messageList.pwdReset.M020_errorMessage001, errorId: ['password'] }});
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    if (password !== rePassword) {
      this.setState({ errorMap: { ERROR: messageList.pwdReset.M022_errorMessage003, errorId: ['password', 'rePassword'] }, password: '', rePassword: ''});
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    if (otp === '') {
      this.setState({ errorMap: { ERROR: messageList.pwdReset.M021_errorMessage002, errorId: ['otp'] }});
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    try {
      // ローディング開始
      this.setState({ loading: true });

      // 共通項目をパラメータに設定
      let params = {
        newPassword: password,
        onetimePassword: otp,
        onetimeTid: onetimeTid
      };
      // アクショントークン・セッショントークンは、取得できた場合のみ設定
      actionToken && (params.action_token = actionToken);
      sessionToken && (params.session_token = sessionToken);

      // 3Keyパスワード再設定API
      axios
        .put( process.env.REACT_APP_URL_CO_SC_API_PASSWORD_RESET,params,
          {headers: {'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                     'Cache-Control': 'no-store',
                     'Pragma': 'no-cache'}}
        )
        .then( response => {
          this.setState({
                          errorMap: null,
                          complete: true,
                          loading: false
                        });
          // GA計測用データレイヤースクリプトを追加する
          window.addDataLayerScript('jmbauth_pwd_reset_completion');
        })
        .catch( error => {
          if ( error.response ) {
            if ( error.response.status === 400 ) {
              // Transmitサービスから返却されるリスクスコアがリスク高の場合
              if (error.response.data.errorCode && error.response.data.errorCode === 'CS-API-901-400-0002') {
                // 操作拒否エラー画面に遷移する
                this.props.history.push({
                  pathname:`${process.env.REACT_APP_CONTEXT_PATH}/deny_error`,
                });
              }
              else {
                this.setState({ errorMap:
                  { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdReset.M023_errorMessage004 },
                  loading: false, password: '', rePassword: '', otp: ''
                });
                // エラーメッセージ表示領域に遷移する
                window.location="#JS_error";
              }
            }
            else if ( error.response.status === 401 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdReset.M023_errorMessage004 },
                loading: false, password: '', rePassword: '', otp: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            else if ( error.response.status === 403 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdReset.M023_errorMessage004 },
                loading: false, password: '', rePassword: '', otp: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            else if ( error.response.status === 500 ) {

              // システムエラー画面表示
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }
            else {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdReset.M023_errorMessage004 },
                loading: false, password: '', rePassword: '', otp: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.pwdReset.M023_errorMessage004 },
              loading: false, password: '', rePassword: '', otp: ''
            });
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
        })
    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.pwdReset.M023_errorMessage004 },
        loading: false, password: '', rePassword: '', otp: ''
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";

    } finally {
    }
  }

  // パスワードリセット開始画面[再設定する]ボタン押下時処理
  mailCheck = async () => {

    const { id, birth_y, birth_m, birth_d } = this.state;

    // お得意様番号が7桁の場合は先頭に00でパディングして9桁で送信する
    let userId;
    if (id && id.length === 7) {
      userId = id.padStart(9, '00');
    }
    else {
      userId = id;
    }
    // パディング処理後の値をstateのお得意様番号(00パディング後)に設定する
    this.setState({ requestId: userId });

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken = null;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("password_reset_reset_start", { correlationId: l_sid, claimedUserId: userId });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // バリデーションチェックを行う
    if (id === '') {
      this.setState({ errorMap: { ERROR: messageList.pwdResetStart.M016_errorMessage001, errorId: ['id'] }
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    if (birth_d === '' || birth_m === '' || birth_y === '') {
      this.setState({ errorMap: { ERROR: messageList.pwdResetStart.M017_errorMessage002, errorId: ['birth_d', 'birth_m', 'birth_y'] }});
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    try {

      // ローディング開始
      this.setState({ loading: true });

      // 3Keyパスワード再設定メール送信要求API
      axios
        .post( process.env.REACT_APP_URL_CO_SC_API_MAIL_PASSWORD_RESET,
          {
            id: userId,
            birthday: birth_y + ('0' + birth_m).slice(-2) + ('0' + birth_d).slice(-2),
            onetimeMailType: process.env.REACT_APP_ONE_TIME_MAIL
          },
          {headers: {'accept-language': window.changeLang(sessionStorage.getItem("lang")),
                     'Cache-Control': 'no-store',
                     'Pragma': 'no-cache'}}
        )
      .then( response => {
        if ( response.data.maskmail || response.data.maskphonenumber) {
          this.setState({ errorMap: null,
            onetimeTid: response.data.onetimeTid,
            maskmail: response.data.maskmail,
            mailCheck: true,
            password: '',
            rePassword: '',
            otp: '',
            loading: false,
            maskphonenumber: response.data.maskphonenumber
            });

          // GA計測用データレイヤースクリプトを追加する
          window.addDataLayerScript('jmbauth_pwd_reset');
        }
        else {
          this.setState({ errorMap:
            { ERROR: messageList.pwdResetStart.M020_errorMessage004 },
            loading: false, birth_d: '', birth_m: '', birth_y: ''
          });
          // エラーメッセージ表示領域に遷移する
          window.location="#JS_error";
        }
      })
        .catch( error => {
          if ( error.response ) {
            if ( error.response.status === 400 ) {

              // 利用者のワンタイムパスワード通知先が登録されていない
              if (error.response.data.errorCode && error.response.data.errorCode === 'CS-API-302-400-0003') {
                this.props.history.push({
                  pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`,
                  state:{errorScreen: 'ADDRESS_UNREGISTERED_PWDRESET'}
                });
              }
              else {
                this.setState({ errorMap:
                  { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdResetStart.M018_errorMessage003 },
                  loading: false, birth_d: '', birth_m: '', birth_y: ''
                });
                // エラーメッセージ表示領域に遷移する
                window.location="#JS_error";
              }
            }
            else if ( error.response.status === 500 ) {

              // エラー画面に遷移し、処理を終了する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }
            else {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdResetStart.M018_errorMessage003 },
                loading: false, birth_d: '', birth_m: '', birth_y: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.pwdResetStart.M018_errorMessage003 },
              loading: false, birth_d: '', birth_m: '', birth_y: ''
            });
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
        });

    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.pwdResetStart.M018_errorMessage003 },
        loading: false, birth_d: '', birth_m: '', birth_y: ''
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";

    } finally {
    }
  }

  // パスワード表示切り替え処理
  swhichPwdShow = e => {
    this.setState({ showPwd: e.currentTarget.checked });
  }

  // 画面をクローズする
  close = e => {
    window.open('about:blank','_self').close();
  }

  // パスワードリセット開始画面へ戻る処理
  beforeMailCheck = () => {
    // メールチェックフラグ設定
    this.setState({ mailCheck: false, errorMap: null }, () => {

      // GA計測用データレイヤースクリプトを追加する
      window.addDataLayerScript('jmbauth_pwd_reset_start');

      // 生年月日表示設定処理を呼出す
      window.addDateControl();

      // 画面再描画
      this.forceUpdate();
    })
  }

  handleChange = e => {
    this.setState({ [e.currentTarget.name]: e.currentTarget.value.trim() });
  }

  componentDidUpdate(prevProps,prevState) {
    if (prevState.mailCheck !== this.state.mailCheck && this.state.mailCheck){
      if ("OTPCredential" in window) {
        const ac = new AbortController();
        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
            signal: ac.signal,
          })
          .then((otp) => {
            this.setState({ otp : otp.code });
          })
          .catch((err) => {
          });
      }
    }
  }

  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // デザイン定義ファイルを読み込み
    let designJson = require('../jsonFile/design.json');
    // デザイン値をセッションから読み込み
    let design = sessionStorage.getItem('design');

    // JOHNデザインの場合、デザイン値に応じたファイルを設定
    let pwdResetDesign;
    let completeDesign;

    // パスワードリセット開始・リセット画面用のデザインファイル設定
    Object.keys(designJson.pwdReset.I01).forEach(function(data) {
      if (data === design) {
        pwdResetDesign = require('./design/' + designJson.pwdReset.I01[data]);
      }
    });
    if(!pwdResetDesign){
      pwdResetDesign = require('./design/' + designJson.pwdReset.I02['default']);
    }

    // パスワードリセット完了画面用のデザインファイル設定(JOHNデザインのみ設定)
    Object.keys(designJson.pwdReset.I03).forEach(function(data) {
      if (data === design) {
        completeDesign = require('./design/' + designJson.pwdReset.I03[data]);
      }
    });

    // パスワードリセット完了画面
    if (this.state.complete){

      // パスワードリセット完了画面表示
      return (
        <section className="content">
          <Helmet
            title={messageList.pwdResetCompletion.M001_browserTitle} >
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.pwdResetCompletion.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            <div id="JS_error">
            { // エラーメッセージ表示
              (this.state.errorMap && this.state.errorMap.ERROR) &&
              <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
                <div className="ds-inlineNote__details">
                  <div className="ds-inlineNote__summary">
                    <h2 className="ds-inlineNote__heading">
                      <span className="ds-inlineNote__headingIcon">
                        <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.pwdReset.M007_errorIconText}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                        </svg>
                      </span>
                      <span className="ds-inlineNote__headingLabel">{messageList.pwdReset.M008_errorBoxTitle}</span>
                    </h2>
                  </div>
                  <div className="ds-inlineNote__content">
                    <p className="ds-text">{this.state.errorMap.ERROR}</p>
                  </div>
                </div>
              </div>
            }
            </div>

            {/* 操作ボタン表示部 */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  <button className="ds-button__trigger" type="button" onClick={this.close}>
                    <span className="ds-button__label">{messageList.pwdResetCompletion.M003_close}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* 案内表示部 */}
          {(completeDesign) && completeDesign.getDesign(messageList.pwdResetCompletion)}

        </section>
      );
    }

    // パスワードリセット画面
    else if (this.state.mailCheck) {

      // 画面に表示するメッセージを作成する
      let maskMessage = "";
      if(this.state.maskphonenumber){
        maskMessage = messageList.pwdReset.M025_guideMessage005 + this.state.maskphonenumber + messageList.pwdReset.M026_guideMessage006;
      }else if(this.state.maskmail){
        maskMessage = messageList.pwdReset.M003_guideMessage001 + this.state.maskmail + messageList.pwdReset.M004_guideMessage002;
      }else{
        maskMessage = messageList.pwdReset.M003_guideMessage001 + messageList.pwdReset.M004_guideMessage002;
      }

      // パスワードリセット画面表示
      return (
        <section className="content">
          <Helmet
            title={messageList.pwdReset.M001_browserTitle} >
          </Helmet>

          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading"/></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.pwdReset.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            {/* ガイドメッセージ表示部 */}
            {(design !== "JH001N" && design !== "JH004N") ?
              <p className="ds-text">{maskMessage}</p>
              :
              <p className="ds-text">{maskMessage}<br />{messageList.pwdReset.M005_guideMessage003}</p>
            }
            <a href="https://www.jal.co.jp/jp/ja/jmb/jmb-login/number-info/" className="ds-textLink ds-textLink--linkBlank u-fw-bold" target="_blank" rel="noopener noreferrer">
              {messageList.pwdReset.M006_guideMessage004}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.pwdReset.M024_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>

            <div id="JS_error">
            { // エラーメッセージ表示
              (this.state.errorMap && this.state.errorMap.ERROR) &&
              <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
                <div className="ds-inlineNote__details">
                  <div className="ds-inlineNote__summary">
                    <h2 className="ds-inlineNote__heading">
                      <span className="ds-inlineNote__headingIcon">
                        <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.pwdReset.M007_errorIconText}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                        </svg>
                      </span>
                      <span className="ds-inlineNote__headingLabel">{messageList.pwdReset.M008_errorBoxTitle}</span>
                    </h2>
                  </div>
                  <div className="ds-inlineNote__content">
                    <p className="ds-text">{this.state.errorMap.ERROR}</p>
                  </div>
                </div>
              </div>
            }
            </div>

            <div className="formPanel">
              <div className="formPanel__inner">
                <form name="form">

                  <div className="formList">
                    {/* 新パスワード */}
                    <div className="formList__line">
                      <div className="formWrap">
                        <label className="formLabel" htmlFor="LB_input-password-1">
                          <span className="formLabel__text">{messageList.pwdReset.M009_newPassword}</span>
                        </label>
                        <p id="WA_input-password-text" className="formLabelSub">{messageList.pwdReset.M010_newPasswordType}</p>
                        <a href={messageList.pwdReset.M029_noticeUrl001} className="ds-textLink ds-textLink--linkBlank u-fz-12" target="_blank" rel="noopener noreferrer">
                          {messageList.pwdReset.M011_aboutPassword}&nbsp;
                          <span className="ds-textLink__icon">
                            <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.pwdReset.M024_newWindowIcon}>
                              <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                            </svg>
                          </span>
                        </a>
                        <input type={ this.state.showPwd ? "text" : "password"} id="LB_input-password-1"
                          className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('password') ?
                          "ds-textfield is-error" : "ds-textfield"}
                          maxLength="256"
                          aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('password') ? "true" : "false"}
                          aria-describedby="WA_input-password-text"
                          autoComplete="new-password"
                          required
                          name="password" value={this.state.password} onChange={this.handleChange}/>
                      </div>
                    </div>

                    {/* 新パスワードの再入力 */}
                    <div className="formList__line">
                      <div className="formWrap">
                        <label className="formLabel" htmlFor="LB_input-password-2">
                          <span className="formLabel__text">{messageList.pwdReset.M012_reNewPassword}</span>
                        </label>
                        <input type={ this.state.showPwd ? "text" : "password"} id="LB_input-password-2"
                          className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('rePassword') ?
                          "ds-textfield is-error" : "ds-textfield"}
                          maxLength="256"
                          aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('rePassword') ? "true" : "false"}
                          autoComplete="new-password"
                          required
                          name="rePassword" value={this.state.rePassword} onChange={this.handleChange}/>

                        {/* パスワードを表示する */}
                        <label className="ds-checkbox">
                          <input
                            className="ds-checkbox__input"
                            type="checkbox"
                            name="checkPassword"
                            aria-controls="LB_input-password-1 LB_input-password-2"
                            onChange={this.swhichPwdShow}
                          />
                          <span className="ds-checkbox__partsWrap">
                            <span className="ds-checkbox__parts" role="presentation"></span>
                            <span className="ds-checkbox__text">{messageList.pwdReset.M013_showPassword}</span>
                          </span>
                        </label>
                      </div>
                    </div>

                    {/* ワンタイムパスワード */}
                    <div className="formList__line">
                      <div className="formWrap">
                        <label className="formLabel" htmlFor="LB_input-password-3">
                          <span className="formLabel__text">{messageList.pwdReset.M014_otpPassword}</span>
                        </label>
                        <input type="text" id="LB_input-password-3"
                          className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('otp') ?
                          "ds-textfield is-error" : "ds-textfield"}
                          maxLength="6"
                          aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('otp') ? "true" : "false"}
                          inputMode="numeric"
                          required
                          name="otp" value={this.state.otp} onChange={this.handleChange} autoComplete="one-time-code"/>
                      </div>
                    </div>
                  </div>

                  {/* 操作ボタン表示部 */}
                  <div className="buttonLayout buttonLayout--split">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--primary ds-button--large">
                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.pwdReset}>
                          <span className="ds-button__label">{messageList.pwdReset.M016_update}</span>
                        </button>
                      </div>
                    </div>
                    <div className="buttonWrap buttonWrap--left">
                      <div className="ds-button ds-button--tertiary ds-button--large">
                        <button className="ds-button__trigger" type="button" onClick={this.beforeMailCheck}>
                          <span className="ds-button__label">{messageList.pwdReset.M015_return}</span>
                        </button>
                      </div>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>

          {/* 案内表示部 */}
          {(pwdResetDesign) && pwdResetDesign.getDesign(messageList.pwdReset)}

        </section>
      );
    }

    // パスワードリセット開始画面表示
    else {
      return (
        <section className="content">
          <Helmet
            title={messageList.pwdResetStart.M001_browserTitle} >
          </Helmet>

          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading"/></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.pwdResetStart.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            {/* ガイドメッセージ表示部 */}
            <p className="ds-text">{messageList.pwdResetStart.M003_guideMessage001}</p>
            <ul className="ds-listText ds-listText--md">
              <li className="ds-listText__item ds-listText__item--note">{messageList.pwdResetStart.M004_guideMessage002}</li>
            </ul>

            <div id="JS_error">
            { // エラーメッセージ表示
              (this.state.errorMap && this.state.errorMap.ERROR) &&
              <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
                <div className="ds-inlineNote__details">
                  <div className="ds-inlineNote__summary">
                    <h2 className="ds-inlineNote__heading">
                      <span className="ds-inlineNote__headingIcon">
                        <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.pwdResetStart.M005_errorIconText}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                        </svg>
                      </span>
                      <span className="ds-inlineNote__headingLabel">{messageList.pwdResetStart.M006_errorBoxTitle}</span>
                    </h2>
                  </div>
                  <div className="ds-inlineNote__content">
                    <p className="ds-text">{this.state.errorMap.ERROR}</p>
                  </div>
                </div>
              </div>
            }
            </div>

            <div className="formPanel">
              <div className="formPanel__inner">
                <form name="form">

                  <div className="formList">
                    {/* お得意様番号 */}
                    <div className="formList__line">
                      <div className="formWrap">
                        <label className="formLabel" htmlFor="LB_input-jmbnumber-1">
                          <span className="formLabel__text">{messageList.pwdResetStart.M007_id}</span>
                        </label>
                        <input type="text" id="LB_input-jmbnumber-1"
                          className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('id') ?
                          "ds-textfield is-error" : "ds-textfield"}
                          name="id" value={this.state.id}
                          maxLength="9"
                          aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('id') ? "true" : "false"}
                          aria-describedby="LB_input-jmbnumber-1-helper"
                          autoComplete="username"
                          inputMode="numeric"
                          required
                          onChange={this.handleChange} onKeyDown = {e => {if (e.keyCode === 13) e.preventDefault();}}/>
                        <span className="helperText" id="LB_input-jmbnumber-1-helper">{messageList.pwdResetStart.M021_helperText}</span>
                      </div>
                    </div>

                    {/* 生年月日 */}
                    <div className="formList__line">
                      <fieldset className="formWrap formWrap--date JS_birthdayBox">
                        <legend className="formLabel">{messageList.pwdResetStart.M008_brithday1}</legend>
                        <div className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('birth_y') ?
                             "ds-select is-noSelect is-error" : "ds-select is-noSelect"}>
                          <select className="ds-select__field JS_yearList" name="birth_y" id="birth_y"
                            onChange={this.handleChange} value={this.state.birth_y}
                            aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('birth_y') ? "true" : "false"} aria-labelledby="WA_date-desc-1"
                            autoComplete="bday-year">
                            <option value="" disabled hidden>{messageList.pwdResetStart.M011_year}</option>
                          </select>
                        </div>
                        <div className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('birth_m') ?
                             "ds-select is-noSelect is-error" : "ds-select is-noSelect"}>
                          <select className="ds-select__field JS_monthList" name="birth_m" id="birth_m"
                            onChange={this.handleChange} value={this.state.birth_m}
                            aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('birth_m') ? "true" : "false"} aria-labelledby="WA_date-desc-2"
                            autoComplete="bday-month">
                            <option value="" disabled hidden>{messageList.pwdResetStart.M010_month}</option>
                            <option value="1">01</option>
                            <option value="2">02</option>
                            <option value="3">03</option>
                            <option value="4">04</option>
                            <option value="5">05</option>
                            <option value="6">06</option>
                            <option value="7">07</option>
                            <option value="8">08</option>
                            <option value="9">09</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                          </select>
                        </div>
                        <div className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('birth_d') ?
                             "ds-select is-noSelect is-error" : "ds-select is-noSelect"}>
                          <select className="ds-select__field JS_dayList" name="birth_d" id="birth_d"
                            onChange={this.handleChange} value={this.state.birth_d}
                            aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('birth_d') ? "true" : "false"} aria-labelledby="WA_date-desc-3"
                            autoComplete="bday-day">
                            <option value="" disabled hidden>{messageList.pwdResetStart.M009_day}</option>
                          </select>
                        </div>
                        <div className="helperText">
                          <span id="WA_date-desc-1">{messageList.pwdResetStart.M011_year}</span>/ <span id="WA_date-desc-2">{messageList.pwdResetStart.M010_month}</span>/ <span id="WA_date-desc-3">{messageList.pwdResetStart.M009_day}</span>
                        </div>
                      </fieldset>
                    </div>
                  </div>

                  {/* 操作ボタン表示部 */}
                  <div className="buttonLayout">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--primary">
                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.mailCheck}>
                          <span className="ds-button__label">{messageList.pwdResetStart.M012_reset}</span>
                        </button>
                      </div>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>

          {/* 案内表示部 */}
          {(pwdResetDesign) && pwdResetDesign.getDesign(messageList.pwdReset)}

        </section>
      );
    }
  }
}

export default PwdReset
